module.exports = __webpack_public_path__ + "static/home-one-banner-shape-08461777e8374814bd7ec0be76c93418.png";